/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Injectable } from '@angular/core';
import { AbstractRestService, arrayOf, identity, RestSettings, SlicedDataSource } from '@gh/core-data';
import { Observable } from 'rxjs';
import {
  ReportFyaDetailsDto,
  ReportRohcCostCenterFilterDto,
  ReportRohcDetailsDto,
  ReportRohcOfficeCostCenterDto,
  ReportRohcOfficeDto,
  ReportRohcOfficeFilterDto,
} from './report-settings.dto';
import {
  ReportFyaDetailsMapper,
  ReportRohcDetailsMapper,
  ReportRohcOfficeCostCenterMapper,
  ReportRohcOfficeMapper,
} from './report-settings.mapper';

@Injectable()
export class ReportSettingsRestService extends AbstractRestService {
  constructor(settings: RestSettings) {
    super(settings);
  }

  getReporRohc(): Observable<ReportRohcDetailsDto> {
    return this.httpGet(`${this.bp}/reports-settings/region-office-house-cost`, ReportRohcDetailsMapper);
  }

  updateReporRohc(details: ReportRohcDetailsDto): Observable<ReportRohcDetailsDto> {
    return this.httpPut(`${this.bp}/reports-settings/region-office-house-cost`, details, ReportRohcDetailsMapper);
  }

  getReporFya(): Observable<ReportFyaDetailsDto> {
    return this.httpGet(`${this.bp}/reports-settings/financials-ytd-averages`, ReportFyaDetailsMapper);
  }

  updateReporFya(details: ReportFyaDetailsDto): Observable<ReportFyaDetailsDto> {
    return this.httpPut(
      `${this.bp}/reports-settings/financials-ytd-averages`,
      details,
      ReportFyaDetailsMapper,
      ReportFyaDetailsMapper);
  }

  // tslint:disable-next-line:max-line-length
  findAllOfficesAsDataSource(filter: ReportRohcOfficeFilterDto): SlicedDataSource<ReportRohcOfficeDto> {
    return this.createSlicedDataSourceGet(
      `${this.bp}/offices/area-finder`,
      filter,
      identity(),
      arrayOf(ReportRohcOfficeMapper));
  }

  // tslint:disable-next-line:max-line-length
  findAllOfficeCostCentersAsDataSource(filter: ReportRohcCostCenterFilterDto): SlicedDataSource<ReportRohcOfficeCostCenterDto> {
    return this.createSlicedDataSourcePost(
      `${this.bp}/cost-centers/master-cc-finder`,
      filter,
      identity(),
      arrayOf(ReportRohcOfficeCostCenterMapper));
  }
}
